import React from 'react';
import { useParams } from 'react-router-dom';
import EstimateForm from '@/components/estimates/EstimateForm';

const EditEstimatePage = () => {
  const { id } = useParams<{ id: string }>();

  // EstimateForm uses PageLayout internally, no wrapper needed
  return id ? <EstimateForm estimateId={id} /> : null;
};

export default EditEstimatePage;
